// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.4.0@rc-align/es/index.js
// module id = 543
// module chunks = 1